@if (hasConfig) {
    <div
        class="h-100"
        [wdxIsLoading]="commentsIsLoading$ | ngrxPush"
        [hasError]="commentsHasError$ | ngrxPush"
    >
        @if (title) {
            <h5>{{ title }}</h5>
        }
        <div class="h-100 d-flex flex-column">
            @if (allowNewComments) {
                <clmi-comment-input
                    [wdxIsLoading]="commentIsCreating$ | ngrxPush"
                    class="flex-shrink-0"
                    [dynamicHeight]="dynamicHeight"
                    [count]="(commentsPaging$ | ngrxPush)?.totalRecords"
                    [issueCount]="issuesCount"
                    [resolveIssueId]="resolveIssueId"
                    [closeComment]="closeCommentTimestamp"
                    [commentSource]="commentSource"
                    (showIssuesOnly)="showIssuesOnly($event)"
                    (createCommentClicked)="createCommentClicked()"
                ></clmi-comment-input>
            }
            <div
                #commentsContainer
                class="flex-grow-1 overflow-auto"
                data-cy="comment-list"
            >
                @if (comments$ | ngrxPush; as comments) {
                    @for (
                        comment of comments;
                        track comment.id;
                        let i = $index;
                        let last = $last
                    ) {
                        <clmi-comment
                            class="d-block"
                            [class.mb-2]="!last"
                            [reply]="comment.resolves"
                            [comment]="comment"
                            [appMentionClickCallback]="appMentionClickCallback"
                            [resolveIssueId]="resolveIssueId"
                            [readonly]="readonly"
                            (resolveIssueChecked)="resolveIssueChecked($event)"
                        ></clmi-comment>
                    }
                    @if (
                        (!allowNewComments && !comments?.length) ||
                        !comments?.length
                    ) {
                        <atom-feature-svg [svg]="FEATURE_SVG.Comments">
                            {{ FIRST_COMMENT | translateTokenisedString }}
                            <br />
                            &#64;{{
                                MENTION_SOMEONE | translateTokenisedString
                            }}
                            @if (commentActivityType === activityType) {
                                {{
                                    SVG_TEXT_REDERENCE
                                        | translateTokenisedString
                                }}
                            }
                        </atom-feature-svg>
                    }
                }
            </div>
        </div>
    </div>
}
